// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('product.brands.new', {
        url:'/new',
        views: {"productView@product": {
            templateUrl: 'main/product/brands/brand/brand.tpl.html',
            controller: 'BrandController as vm'
        }},
        resolve: {
            brand: function() { return {}; },
            mainGroups: mainGroupsResolver,
            isNewBrand: function() { return true; },
            companies: companiesResolver,
            brandCategories: brandCategoriesResolver,
            barcodeTypes: barcodeTypesResolver,
            tenantConfig: tenantConfigResolver,
            vats: vatsResolver,
            variantGroups: variantGroupsResolver,
            salesChannels: salesChannelResolver,
            locations: locationsResolver,
            isBrandConnectEnabled: brandConnectEnabledResolver
        }
    });

    $stateProvider.state('product.brands.brand', {
        url:'/{brandId}',
        views: {"productView@product": {
            templateUrl: 'main/product/brands/brand/brand.tpl.html',
            controller: 'BrandController as vm'
        }},
        resolve: {
            brand: brandResolver,
            mainGroups: mainGroupsResolver,
            isNewBrand: function() { return false; },
            companies: companiesResolver,
            brandCategories: brandCategoriesResolver,
            barcodeTypes: barcodeTypesResolver,
            tenantConfig: tenantConfigResolver,
            vats: vatsResolver,
            variantGroups: variantGroupsResolver,
            salesChannels: salesChannelResolver,
            locations: locationsResolver,
            isBrandConnectEnabled: brandConnectEnabledResolver
        }
    });

}

// @ngInject
function mainGroupsResolver(BrandsApiService) {
    return BrandsApiService.getMainGroups();
}

// @ngInject
function brandResolver($stateParams, BrandsApiService) {
    return BrandsApiService.getBrand($stateParams.brandId);
}

// @ngInject
function companiesResolver(BrandsApiService) {
    return BrandsApiService.getCompanies();
}

// @ngInject
function brandCategoriesResolver(BrandsApiService) {
    return BrandsApiService.getBrandCategories();
}

// @ngInject
function barcodeTypesResolver(BrandsApiService) {
    return BrandsApiService.getBarcodeTypes();
}

// @ngInject
function tenantConfigResolver(BrandsApiService) {
    return BrandsApiService.getTenantConfig();
}

// @ngInject
function vatsResolver(VatsApiService) {
    return VatsApiService.getVats();
}

//@ngInject
function variantGroupsResolver(BrandsApiService) {
    return BrandsApiService.getVariantGroups();
}

//@ngInject
function salesChannelResolver(BrandsApiService) {
    return BrandsApiService.getSalesChannels();
}

// @ngInject
function locationsResolver(LocationsApiService) {
    return LocationsApiService.listAll();
}

// @ngInject
function brandConnectEnabledResolver(FeatureSwitchService) {
    return FeatureSwitchService.isBrandConnectEnabled();
}


// @ngInject
function BrandController($rootScope, $state, vats, brand, mainGroups, loadSpinnerService, BrandsApiService, isNewBrand, companies, variantGroups, brandCategories, barcodeTypes, tenantConfig, salesChannels, locations, isBrandConnectEnabled) {
    var vm = this;
    vm.currentUser = $rootScope.currentUser;

    var brandCopy = {};

    vm.brand = brand;
    vm.mainGroups = [];
    vm.selectedMainGroups = [];
    vm.selectedCompanies = [];
    vm.removedCompanies = [];
    vm.companies = companies;
    vm.brandCategories = brandCategories;
    vm.barcodeTypes = barcodeTypes;
    vm.vats = vats;
    vm.salesChannels = salesChannels;

    vm.addMainGroups = addMainGroups;
    vm.removeCompany = removeCompany;
    vm.enableEditing = enableEditing;
    vm.cancelEditing = cancelEditing;
    vm.saveBrand = saveBrand;

    vm.isNewBrand = isNewBrand;
    vm.isEditing = vm.isNewBrand;

    vm.tenantConfig = tenantConfig;
    vm.isAllInformationValid = isAllInformationValid;
    vm.isBrandCodeValid = isBrandCodeValid;
    vm.isBrandCategoryValid = isBrandCategoryValid;
    vm.isBarcodeTypeValid = isBarcodeTypeValid;
    vm.isBrandDescriptionValid = isBrandDescriptionValid;

    vm.variantGroups = variantGroups;
    vm.toggleDisplayForm = toggleDisplayForm;

    vm.devFeaturesEnabled = localStorage.getItem('devFeature_reactBrandView') === 'true';
    vm.isBrandConnectEnabled = isBrandConnectEnabled;
    vm.locations = locations;
    vm.brandConnectSelectedLocations = [];
    vm.connectBrandSupplier = connectBrandSupplier;
    vm.disconnectBrandSupplier = disconnectBrandSupplier;

    activate();

    function activate() {
        prepareData();

        if (vm.isNewBrand) {
            vm.brand = {};
            vm.brand['company'] = vm.companies[0];
        }

    }

    function addMainGroups() {
        var brands = [vm.brand];
        var mainGroups = vm.selectedMainGroups;

        loadSpinnerService.start('mainSpinner');
        BrandsApiService.createItemGroups(mainGroups, brands).then(function() {
            BrandsApiService.getBrand(vm.brand.id).then(function(response) {
                vm.brand = response;
                prepareData();
                vm.selectedMainGroups = [];
            }, function(error) {
                console.log(error);
            });
        }, function(error) {
            console.log(error);
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function removeCompany(company) {
        console.log('Removing ' + company.id + ' (' + company.companyName + ') from company list');
        vm.removedCompanies.push(company);
        vm.brand.companies = vm.brand.companies.filter(function (obj) {
            return obj.id !== company.id;
        });
    }

    function enableEditing() {
        brandCopy = angular.copy(vm.brand);
        vm.isEditing = true;
    }

    function cancelEditing() {
        vm.brand = brandCopy;
        vm.isEditing = false;
        vm.selectedMainGroups = [];
        vm.selectedCompanies = [];
        vm.removedCompanies = [];
    }

    function saveBrand() {
        if (vm.isNewBrand) {
            saveNewBrand();
        } else {
            updateBrand();
        }
    }

    function saveNewBrand() {
        loadSpinnerService.start('mainSpinner');

        //Make sure preferred supplier is in list of suppliers
        if (!vm.brand.companies) { vm.brand.companies = []; }
        if (!_.find(vm.brand.companies, function(c) { return c.id === vm.brand.company.id; })) {
            vm.brand.companies.push(vm.brand.company);
        }

        BrandsApiService.createBrand(vm.brand, vm.selectedMainGroups,
            vm.selectedCompanies, vm.removedCompanies).then(function(response) {
            vm.brand = response;
            prepareData();
            vm.selectedMainGroups = [];
            vm.selectedCompanies = [];
            vm.removedCompanies = [];
            vm.isNewBrand = false;
            vm.isEditing = false;
            $state.go('product.brands.brand', {brandId: response.id});
        }, function(error) {
            console.log(error);
        }).then(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function updateBrand() {
        loadSpinnerService.start('mainSpinner');

        //Make sure preferred supplier is in list of suppliers
        if (!_.find(vm.brand.companies, function(c) { return c.id === vm.brand.company.id; })) {
            vm.brand.companies.push(vm.brand.company);
        }

        BrandsApiService.updateBrand(vm.brand, vm.selectedMainGroups,
            vm.selectedCompanies, vm.removedCompanies).then(function(response) {
            vm.brand = response;
            prepareData();
            vm.selectedMainGroups = [];
            vm.selectedCompanies = [];
            vm.removedCompanies = [];
            vm.isEditing = false;
        }, function(error) {
            console.log(error);
        }).then(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function connectBrandSupplier() {
        var locationIds = vm.brandConnectSelectedLocations.map(function(loc) { return loc.id; });

        loadSpinnerService.start('mainSpinner');
        BrandsApiService.connectBrandSupplier(vm.brand.id, vm.brand.brandConnectIdentifier, locationIds).then(function () {
            return BrandsApiService.getBrand(vm.brand.id);
        }).then(function (response) {
            vm.brand = response;
            vm.brandConnectSelectedLocations = [];
            prepareData();
        }, function (error) {
            console.log(error);
        }).finally(function () {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function disconnectBrandSupplier() {
        loadSpinnerService.start('mainSpinner');
        BrandsApiService.disconnectBrandSupplier(vm.brand.id).then(function () {
            return BrandsApiService.getBrand(vm.brand.id);
        }).then(function (response) {
            vm.brand = response;
            prepareData();
        }, function (error) {
            console.log(error);
        }).finally(function () {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function prepareData() {
        if (vm.brand === undefined) {
            return;
        }

        // Filter out mainGroups that are already added.
        var tempMainGroups = [];
        _.forEach(mainGroups, function(mainGroup) {
            if (!_.find(vm.brand.itemGroups, function(igrp) { return igrp.mainGroup.id === mainGroup.id; })) {
                tempMainGroups.push(mainGroup);
            }
        });

        vm.mainGroups = _.sortBy(tempMainGroups, function(mainGroup) {
            return mainGroup.mainGroupCode;
        });
        if (vm.brand.mainGroups === undefined || vm.brand.mainGroups.length === 0) {
            vm.brand.mainGroups = vm.mainGroups;
        }

        if (vm.brand.companies === undefined || vm.brand.companies.length === 0) {
            vm.brand.companies = companies;
        }
        vm.brand.companies = _.sortBy(vm.brand.companies, function(company) {
            return company.companyName;
        });
    }

    function isAllInformationValid() {
        return (
            !vm.isNewBrand && 
            isBrandDescriptionValid()
        ) || (
                isBrandCodeValid() &&
                isBrandCategoryValid() &&
                isBarcodeTypeValid()
        );
    }

    function isBrandCodeValid() {
        var isBrandCodeAlreadyAssigned = _.find(vm.tenantConfig.assignedBrandCodes, function(code) {
            return vm.brand.brandCode === code;
        });

        if (!isBrandCodeAlreadyAssigned && isNumeric(vm.brand.brandCode) && vm.brand.brandCode.length === vm.tenantConfig.articleBrandCodeLength) {
            return true;
        } else {
            return false;
        }
    }

    function isBrandCategoryValid() {
        if (!vm.brand.brandCategory) {
            return false;
        }
        if (vm.brand.brandCategory.id <= 0) {
            return false;
        }
        return true;
    }

    function isBarcodeTypeValid() {
        if (!vm.brand.barcodeType) {
            return false;
        }
        if (vm.brand.barcodeType.id <= 0) {
            return false;
        }
        return true;
    }

    function isBrandDescriptionValid(){
        return vm.brand.brandDescription && vm.brand.brandDescription.length > 0;
    }

    function toggleDisplayForm(itemGroup) {
        console.log("Toggling");
        if (!itemGroup.showEditForm) { itemGroup.showEditForm = false; }
        itemGroup.showEditForm = !itemGroup.showEditForm;
    }


    function isNumeric(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    }

}

angular
    .module('brands.brand', [])
    .config(stateConfig)
    .controller('BrandController', BrandController);
